import { HTTP as http } from '../http-common'

let config = {
  headers: {
    "evn-token": "RTJ5N1JiajU5Z3NWcDdFSmJ4cDFyUSUzRCUzRDpmY0lDTSUyRmppQUJsc1Y0UXdicHRqMmclM0QlM0Q",
  },
};

export default {
  async verify() {
    return await http.get(`/api/auth/verify`, config)
  }
}
